// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

import WebSocketClient from './websocket_client.jsx';

var WebClient = new WebSocketClient();
export default WebClient;



// WEBPACK FOOTER //
// ./client/web_websocket_client.jsx